/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import {
  parseProductTourDefinition,
  productTourRegistryKey,
  type ProductTourDefinition,
} from './product-tour.utils';

export const PRODUCT_TOUR_REGISTRY_GLOBAL = '__QUBEPRO_PRODUCT_TOURS__';
export const PRODUCT_TOUR_REGISTRY_CHANGED_EVENT = 'qubepro:product-tour:registry-changed';

type ProductTourWindow = Window & {
  [PRODUCT_TOUR_REGISTRY_GLOBAL]?: Record<string, unknown>;
};

function getRegistry(): Record<string, unknown> {
  const host = window as ProductTourWindow;
  if (!host[PRODUCT_TOUR_REGISTRY_GLOBAL]) {
    host[PRODUCT_TOUR_REGISTRY_GLOBAL] = {};
  }
  return host[PRODUCT_TOUR_REGISTRY_GLOBAL]!;
}

function notifyRegistryChanged(): void {
  window.dispatchEvent(new CustomEvent(PRODUCT_TOUR_REGISTRY_CHANGED_EVENT));
}

export function registerProductTourDefinition(value: unknown): () => void {
  const definition = parseProductTourDefinition(value);
  if (!definition) {
    throw new Error('Invalid QubePro product tour definition.');
  }
  const key = productTourRegistryKey(definition);
  getRegistry()[key] = definition;
  notifyRegistryChanged();
  return () => {
    const registry = getRegistry();
    if (registry[key] === definition) {
      delete registry[key];
      notifyRegistryChanged();
    }
  };
}

export function listRegisteredProductTours(applicationCode: string): ProductTourDefinition[] {
  const normalizedAppCode = applicationCode.trim().toUpperCase();
  return Object.values(getRegistry())
    .map(parseProductTourDefinition)
    .filter((definition): definition is ProductTourDefinition => (
      definition !== null && definition.applicationCode === normalizedAppCode
    ))
    .sort((left, right) => (
      (right.priority ?? 0) - (left.priority ?? 0)
      || right.version - left.version
      || left.id.localeCompare(right.id)
    ));
}

export function subscribeProductTourRegistry(listener: () => void): () => void {
  window.addEventListener(PRODUCT_TOUR_REGISTRY_CHANGED_EVENT, listener);
  return () => window.removeEventListener(PRODUCT_TOUR_REGISTRY_CHANGED_EVENT, listener);
}
